import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Layout from "../layout";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../../features/authSlice";
import { Row, Col, Card, Button, Spinner } from "react-bootstrap";
import { IoAddCircle } from "react-icons/io5";

const LogistikList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, user } = useSelector((state) => state.auth);
  const [userData, setUserData] = useState([]);
  const [userAuth, setUserAuth] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user?.uuid) {
      const fetchData = async () => {
        const token = localStorage.getItem("token");

        try {
          const response = await axios.get(
            `https://c-greenproject.org:8000/users/${user.uuid}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setUserAuth(response.data);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };

      fetchData();
    }
  }, [user?.uuid]);

  useEffect(() => {
    if (user?.uuid) {
      const fetchData = async () => {
        const token = localStorage.getItem("token");

        try {
          const response = await axios.get(
            `https://c-greenproject.org:8000/logistikdasar`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setUserData(response.data);
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchData();
    }
  }, [user?.uuid]);

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
    if (user && user.role !== "logistik") {
      navigate("/data-logistik");
    }
  }, [isError, user, navigate]);

  const deleteProduct = async (id) => {
    if (window.confirm("Apakah Anda yakin ingin menghapus data ini?")) {
      const token = localStorage.getItem("token");

      try {
        await axios.delete(
          `https://c-greenproject.org:8000/logistikdasar/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const updatedUserData = userData.filter((data) => data.id !== id);
        setUserData(updatedUserData);
        alert("Data berhasil dihapus.");
      } catch (error) {
        console.error("Error deleting data:", error);
        alert("Terjadi kesalahan saat menghapus data.");
      }
    }
  };

  const formatNumber = (number) => {
    return number.toLocaleString("id-ID");
  };

  return (
    <Layout>
      <div>
        <h2 className="title">
          <strong>Data Logistik</strong>
        </h2>
        {user && (user.role === "admin" || user.role === "logistik") && (
          <Link to="/data-logistik/add" className="btn btn-primary mb-2">
            <IoAddCircle/> Add Data Logistik
          </Link>
        )}

        {loading ? (
          <div className="d-flex justify-content-center mt-5">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : userData.length ? (
          userData.map((data, index) => (
            <Card key={index} className="mb-4 p-4">
              {user &&
                (user.role === "admin" || user.role === "perusahaan") && (
                  <Row className="mb-3">
                    <Col md={4}>
                      <h5 className="fw-bold">Nama Logistik</h5>
                    </Col>
                    <Col md={8}>
                      <p>{user.name}</p>
                    </Col>

                    <Col md={4}>
                      <h5 className="fw-bold">Email Logistik</h5>
                    </Col>
                    <Col md={8}>
                      <p>{user.email}</p>
                    </Col>

                    <Col md={4}>
                      <h5 className="fw-bold">User ID Logistik</h5>
                    </Col>
                    <Col md={8}>
                      <p>{user.uuid}</p>
                    </Col>
                  </Row>
                )}

              <Row className="mb-3">
                <Col md={4} className="fw-bold text-muted mb-1">
                  ID Kendaraan
                </Col>
                <Col md={8}>
                  <p>{data.idKendaraan}</p>
                </Col>

                <Col md={4} className="fw-bold text-muted mb-1">
                  Asal Lokasi
                </Col>
                <Col md={8}>
                  <p>{data.asal}</p>
                </Col>

                <Col md={4} className="fw-bold text-muted mb-1">
                  Nomor Plat
                </Col>
                <Col md={8}>
                  <p>{data.PolisiKendaraan}</p>
                </Col>

                <Col md={4} className="fw-bold text-muted mb-1">
                  Jenis Kendaraan
                </Col>
                <Col md={8}>
                  <p>{data.jenisKendaraan}</p>
                </Col>

                <Col md={4} className="fw-bold text-muted mb-1">
                  Kapasitas Angkut
                </Col>
                <Col md={8}>
                  <p>{formatNumber(data.kapasitasAngkut)} kg</p>
                </Col>
              </Row>

              {user.role === "admin" && (
                <Row>
                  <Col className="d-flex justify-content-end">
                    <Button
                      variant="danger"
                      onClick={() => deleteProduct(data.id)}
                    >
                      Delete
                    </Button>
                  </Col>
                </Row>
              )}
            </Card>
          ))
        ) : (
          <p>Tidak ada data logistik yang tersedia.</p>
        )}
      </div>
    </Layout>
  );
};

export default LogistikList;
